import React from 'react';
import { useDispatch } from "react-redux";

import ActionButton from "../../../../Components/Buttons/ActionButton";
import { showModal } from "../../../../Redux/GlobalReducer";
import { MODAL_EDIT_BOOKING } from "../../Pages/BookingsLog";

const EditBookingButton = (props) => {
    const dispatch = useDispatch();

    const handleEdit = () => {
        dispatch( showModal(MODAL_EDIT_BOOKING, props.booking.id) );
    }

    if (!props.booking || !props.booking.can_edit) {
        return null;
    }

    return (
        <ActionButton
            icon="fa-pencil"
            className="edit-booking"
            onClick={(evt) => handleEdit()}
            isDisabled={!!props.booking.archived_at}
        />
    )
}

export default EditBookingButton;
